<template>
  <v-card
    v-bind="$attrs"
    flat
    rounded="lg"
    class="content-background"
  >
    <slot />
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "TCard",
});
</script>
